<template>
	<div class="header">
		<img
			src="../assets/whiteLogo.png"
			class="header_logo"
			alt=""
			@click="goPage('/')"
		/>
		<div class="header_right">
			<!-- <div class="search">
            <el-autocomplete
              clearable
              v-model="keyword"
              :fetch-suggestions="querySearchAsync"
              :trigger-on-focus="false"
              placeholder="请输入内容"
              class="input"
            >
              <i
                v-if="!keyword"
                class="el-icon-search el-input__icon searchIcon"
                slot="suffix"
                @click="handleIconClick"
              >
              </i>
              <slot>
                <p v-for="(item,index) in list" :key="index" v-html="item.value" @click="handleSelect(item)"></p>
              </slot>
            </el-autocomplete>
          </div> -->
			<!-- <div class="ask-btn" @click="dialogRelease = true">提问</div>
          <div class="jifenbang" @click="toLeaguePage">
            <img src="@/pc/assets/images/pc-jifen.png" style="width:20px; height:20px; margin-right: 2px; margin-bottom: 6px;"/>
            <span>积分榜</span>
          </div>

          <div class="message">
            <img src="@/pc/assets/images/point2.png" class="message_icon">
            <span class="jifen">积分 | {{ info.integration }}</span>
            <div class="balloon anim_fade_image" v-if="num !=0 ">+{{num}}</div>
          </div> -->

			<!-- <a href="/#/me" class="name">Hi，{{ info.name }}</a> -->
			<span class="name">Hi，{{ info.name }}</span>
		</div>

		<el-dialog
			:append-to-body="true"
			:visible.sync="dialogRelease"
			:close-on-click-modal="false"
			@close="closeEvent"
			width="1000px"
		>
			<div class="dialog">
				<release ref="release"></release>
				<span slot="footer" class="dialog-footer">
					<el-button
						type="primary"
						@click="submitRelease"
						:loading="btnLoading"
						style="background: #d5001c; border: 0"
						>发布</el-button
					>
				</span>
			</div>
		</el-dialog>

		<!-- 敏感词检测 -->
		<el-dialog
			:visible.sync="checkVisible"
			:append-to-body="true"
			width="30%"
		>
			<div style="text-align: center; margin-top: 20px">
				内容包含敏感词：<span style="color: #d5001c">{{
					sensitiveWord
				}}</span>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button
					type="primary"
					@click="checkVisible = false"
					style="background: #d5001c; border: 0"
					>确认</el-button
				>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import release from "@/pc/components/release/globalAsk";

export default {
	data() {
		return {
			info: {},
			keyword: "",
			num: "",
			list: [],

			dialogRelease: false,
			btnLoading: false,

			checkVisible: false,
			sensitiveWord: "",
		};
	},
	components: {
		release,
	},
	mounted() {
		this.getUser();
		this.qiandao();
	},
	watch: {
		keyword(val) {
			//  this.search()
		},
	},
	methods: {
		toLeaguePage() {
			this.$router.push({ path: "/manage/leagueTable" });
		},
		submitRelease() {
			this.btnLoading = true;
			setTimeout(() => {
				this.btnLoading = false;
			}, 800);
			let data = this.$refs.release.submitModelRelease();
			console.log(data);
			this.h5Ajax(
				"post",
				"$/questions/checkSensitiveWord",
				{
					content: data.content,
				},
				true
			).then((r) => {
				if (r && r.keyword) {
					this.sensitiveWord = r.keyword;
					this.checkVisible = true;
				} else {
					this.h5Ajax(
						"post",
						"$/questions/add",
						{
							relation: "",
							categoryId: data.categoryId,
							title: data.title,
							content: data.content,
							attachments: data.file,
						},
						true
					).then((res) => {
						if (res === true) {
							this.$message({
								message: "发布成功",
								type: "success",
							});
							this.dialogRelease = false;
						}
					});
				}
			});
		},
		closeEvent() {
			this.$refs.release.clearData();
		},

		querySearchAsync(queryString, callback) {
			var list = [{}];

			this.h5Ajax(
				"get",
				"$/questions/searchListPage",
				{
					keyword: this.keyword,
					page: 1,
					size: 10,
				},
				true
			)
				.then((res) => {
					this.list = res.content.map((x) => {
						return {
							...x,
							value: x.title,
						};
					});
					callback(list);
				})
				.catch((err) => {
					console.error("err:" + err);
				});
		},

		handleSelect(item) {
			this.keyword = "";
			this.$router.push({
				path: "/model/detail",
				query: { id: item.id, typeId: item.categoryId, iid: 1 },
			});
			window.localStorage.setItem("menuIndex", item.categoryName);
		},

		handleIconClick(ev) {
			// this.querySearchAsync()
		},

		goPage(url) {
			this.$router.push({ path: url });
		},
		getUser() {
			//  获取信息
			this.h5Ajax("get", "$/user/info", {}, true)
				.then((res) => {
					console.log(res, "个人信息");
					this.info = res;
				})
				.catch((err) => {
					console.error("err:" + err);
				});
			this.h5Ajax("get", "$/inbox/getUnreadInfoCount", {}, true)
				.then((res) => {
					this.info = {
						...this.info,
						messageCount: res,
					};
					console.log("indo", this.info);
				})
				.catch((err) => {
					console.error("err:" + err);
				});
		},
		qiandao() {
			this.h5Ajax("post", "$/user/signIn", {}, true)
				.then((res) => {
					console.log(res, "签到");
					this.num = res.integration;
					console.log(this.num);
					if (this.num != 0) {
						setTimeout(() => {
							this.showPoint();
							this.getUser();
						}, 800);
					}
				})
				.catch((err) => {
					console.error("err:" + err);
				});
		},
		showPoint() {
			var obj = document.getElementsByClassName("balloon")[0];
			obj.style.bottom = "0px";
			var y = 110;
			var init = 0;
			var clock = setInterval((r) => {
				init++;
				if (init < 20) {
					obj.style.bottom = init * 5 + "px";
				} else {
					if (obj.style.bottom != "110px") {
						obj.style.bottom = "110px";
						obj.style.display = "none";
					}
					clearInterval(clock);
				}
			}, 100);
		},
		//  search(){
		//    this.h5Ajax("get", "$/questions/searchListPage", {
		//       keyword:this.keyword,
		//       page:1,
		//       size:10
		// 		}, true)
		// 			.then(res => {
		// 				console.log(res)
		// 			})
		// 			.catch(err => {
		// 				console.error("err:" + err);
		// 			});
		//  }
	},
};
</script>

<style lang="scss" scoped>
.searchIcon {
	cursor: pointer;
	line-height: 30px !important;
}
.balloon {
	width: 0.6rem;
	height: 0.55rem;
	text-align: center;
	background-size: cover;
	color: #000;
	font-size: 0.16rem;
	font-weight: 700;
	padding-top: 0.05rem;
	right: -30px;
	bottom: -47px;
	position: absolute;
}
@-webkit-keyframes fadeInOut {
	0% {
		opacity: 0;
	}
	25% {
		opacity: 0.5;
	}
	/*30%{
        opacity: 1;   bottom: 0.3rem
    }*/
	50% {
		opacity: 1;
	}
	75% {
		opacity: 0.5;
	}
	/*80% {
		opacity:0.5;bottom: 0.9rem
    }*/
	100% {
		opacity: 0;
	}
}
.anim_fade_image {
	font-style: italic;
	font-size: 32px;
	font-weight: bold;
	position: absolute;
	z-index: 99999;
	animation-name: fadeInOut;
	-webkit-animation-name: fadeInOut;
	-webkit-animation-timing-function: ease-in-out;
	animation-timing-function: ease-in-out;
	animation-iteration-count: infinite;
	-webkit-animation-iteration-count: infinite;
	animation-duration: 2s;
	-webkit-animation-duration: 2s;
	animation-direction: alternate;
	-webkit-animation-direction: alternate;
}
.header {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 70px;
	box-shadow: 0px 3px 6px rgba(110, 116, 134, 0.24);
	background: #000000;
	background-image: url(../assets/header.png);
	background-size: 130% 100px;
	background-position: center;
	background-repeat: no-repeat;
	overflow: hidden;
	.header_logo {
		// width: 80px;
		height: 13px;
		margin-left: 30px;
		cursor: pointer;
		// margin: 0 auto;
	}

	.header_right {
		display: flex;
		align-items: center;
		padding: 0 20px;
		height: 70px;
		position: absolute;
		right: 0;
		.search {
			position: relative;
			display: flex;
			align-items: center;

			.input {
				min-width: 210px;
				height: 30px;
				line-height: 30px;
				border: 1px solid #e3e4e5;
				background: #fff;
				border-radius: 2px;
				font-size: 14px;
				padding: 0px 0px 0px 12px;
				box-sizing: border-box;
				/deep/ .el-input__inner {
					padding: 0 !important;
					height: 30px !important;
					line-height: 30px !important;
					//  width: 126% !important;
					// width: 196px!important;
					border: 0;
					background: rgba(0, 0, 0, 0);
				}
				/deep/ .el-input__icon {
					line-height: 30px !important;
				}
			}

			.search_icon {
				position: absolute;
				top: 5px;
				right: 14px;
				color: #666;
				font-size: 18px;
			}
		}

		.sign {
			width: 80px;
			height: 24px;
			display: flex;
			justify-content: center;
			align-items: center;
			border: 1px solid #000;
			margin-left: 24px;
			box-shadow: 0px 3px 6px rgba(110, 116, 134, 0.24);
			.sign_icon {
				width: 16px;
				height: 16px;
			}
			.sign_text {
				color: #000;
				font-size: 14px;
				font-weight: bold;
			}
		}

		.message {
			margin: 0 15px;
			position: relative;
			display: flex;
			align-items: center;
			.message_icon {
				width: 16px;
			}
			.jifen {
				color: #7c8894;
				font-size: 14px;
				margin-left: 4px;
				font-weight: 800;
			}
		}

		.name {
			font-size: 14px;
			color: #c9cacb;
			font-weight: bold;
		}

		.status {
			font-size: 14px;
			color: #7c8894;
			font-weight: bold;
			border-left: 2px solid #7c8894;
			margin-left: 6px;
			padding-left: 6px;
			line-height: 18px;
		}
	}
}

.ask-btn {
	width: 76px;
	height: 32px;
	line-height: 32px;
	text-align: center;
	background: #d5001c;
	color: #fff;
	font-size: 14px;
	font-weight: 700;
	margin-left: 8px;
	cursor: pointer;
}

/deep/ .el-dialog__body {
	padding: 10px 20px;

	.dialog-footer {
		margin-top: 15px;
		display: flex;
		justify-content: flex-end;
	}
}

.jifenbang {
	margin-left: 60px;
	font-size: 14px;
	cursor: pointer;
	color: #000;
	font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/pc/components/header.vue